<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-cctv`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.048 6.486l22.618 4.071a2 2 0 011.425 2.882l-7.41 14.438a2 2 0 01-2.153 1.051l-8.673-1.648v7.926a2.1 2.1 0 01-1.95 2.095l-.15.005H6v3.887a1 1 0 01-1 1H3a1 1 0 01-1-1v-12a1 1 0 011-1h2a1 1 0 011 1v4.113h11.856l-.001-6.786-8.887-1.687a2 2 0 01-1.457-2.771l6.352-14.414a2 2 0 012.185-1.162zm26.982 10.89l1.973.252a1 1 0 01.768 1.439l-4.083 8.165a1 1 0 01-1.098.532l-1.97-.41a1 1 0 01-.688-1.432l4.08-8.008a1 1 0 011.017-.538zm-26.141-6.674l-4.703 10.67 17.619 3.347 5.494-10.704-18.41-3.313z"/></svg>
</template>
<script>

export default {
  name: 'IconCctv',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
